<template>
  <div>
    <div class="template-solicitacao-titulo">{{ titulo }}</div>
    <div class="template-solicitacao-descricao">{{ descricao }}</div>
    <div
      style="height: 600px"
      v-if="internalLoading"
    />
    <div :id="idRender"/>
    <ButtonDefault
      :disabled="internalLoading"
      style="height: 34px; width: 100%;"
      :title="ultimoStep"
      @click="proximo"
    />
  </div>
</template>
<script>
import ButtonDefault from '@/components/buttons/ButtonDefault'
import { mapGetters, mapState } from 'vuex'
import { initForm } from '@mobilesaude/form-builder-sdk'
import useAppDataDriver from '@/utils/useAppDataDriver'

export default {
  name: 'TemplateStepFormularioUnico',
  components: { ButtonDefault },
  props: {
    step: {
      type: Object
    },
    idFuncionalidade: {
      type: [Number, String],
      default: -23
    },
    idTipoOcorrencia: {
      type: [Number, String],
      default: 1
    },
    data: {
      default: () => ({})
    },
    beneficiarioSelecionado: {
      type: Object,
      default: undefined
    },
    stepCount: {
      type: [Number, String],
      default: 1
    },
    stepEnd: {
      type: [Number, String],
      default: 1
    }
  },
  data () {
    return {
      form: null,
      internalLoading: true,
      jsonPreLoadData: {},
      formTimestamp: 1,
      processando: false
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['aplicacao', 'estilo']),
    ...mapState('SetupApp', ['apiFormPreLoadData']),
    idRender () {
      return `form-container-${this.formTimestamp}`
    },
    formBuilderColors () {
      const colors = this.estilo.formBuilder

      if (!colors) {
        return {}
      }

      return {
        primary: colors.corPrincipalFormBuilder,
        errors: colors.corErroFormBuilder,
        alert: colors.corAlertaFormBuilder
      }
    },
    formId () {
      return this.step.formulario.idForm
    },
    titulo () {
      return this.step.formulario.titulo
    },
    descricao () {
      return this.step.formulario.descricao
    },
    ultimoStep () {
      let texto = 'PRÓXIMO'
      if (this.stepCount === this.stepEnd) {
        texto = 'ENVIAR'
      }
      return texto
    }
  },
  methods: {
    async init () {
      this.processando = false
      this.isLoading = true
      this.formTimestamp = Date.now()
      const loader = this.$loading({
        lock: true,
        fullscreen: true,
        customClass: 'myloading'
      })
      await this.preLoadData()

      const formConfig = {
        identifier: this.idRender,
        clientKey: this.aplicacao.clientKey,
        idForm: this.formId,
        colors: { ...this.formBuilderColors }
      }

      if (Array.isArray(this.data.formData) && this.data.formData.length > 0) {
        formConfig.json = this.data.formData[0]
      }

      this.form = initForm(formConfig)

      this.form.on('LOADING', async () => {
        this.form.renderForm(await this.getJsonInjetado())

        setTimeout(() => {
          this.internalLoading = false
          loader.close()
        }, 300)
      })
    },
    async getJsonInjetado () {
      const appDataDriver = useAppDataDriver()
      const keyCustomFields = await this.form.getKeyCustomFields()
      if (!Array.isArray(keyCustomFields.keyCustoms) || keyCustomFields.keyCustoms.length === 0) {
        return false
      }

      let payload = {
        camposFormbuiler: keyCustomFields.keyCustoms,
        beneficiarioSelecionado: this.beneficiarioSelecionado,
        integracao: this.jsonPreLoadData
      }

      return appDataDriver.formatJSON(payload)
    },
    async proximo () {
      if (this.processando) {
        return
      }
      this.processando = true
      const formData = await this.form.validateAll()
      if (!formData || !formData.status) {
        this.processando = false
        return false
      }

      const payloadStep = {
        formData: [formData.data]
      }

      this.$emit('proximo', payloadStep)

      setTimeout(() => {
        this.processando = false
      }, 100)
    },
    async preLoadData () {
      let payloadData = {}

      if (this.beneficiarioSelecionado && this.beneficiarioSelecionado.beneficiarioDados) {
        payloadData = {
          chaveUnica: this.beneficiarioSelecionado.chaveUnica,
          numeroContrato: this.beneficiarioSelecionado.numeroContrato,
          integracao: this.beneficiarioSelecionado.beneficiarioDados.integracao
        }
      }

      this.jsonPreLoadData = await this.apiFormPreLoadData.carregar(
        {
          payload: {
            idFuncionalidade: this.idFuncionalidade,
            idTipoOcorrencia: this.idTipoOcorrencia,
            idTipoSolicitacao: this.step.formulario.idSolicitacaoTemplateTipo || '',
            beneficiarioSelecionado: { ...payloadData }
          },
          handlerErrorIgnore: true
        })
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
</style>
